import { apiPools } from '../../api'
import types from './types'

function incrementRemoveFromLists() {
  return { type: types.INCREMENT_REMOVE_FROM_LIST }
}

function updateIsListAvailable(isListsAvailable) {
  return {
    type: types.UPDATE_IS_LIST_AVAILABLE,
    isListsAvailable
  }
}

/**
 * Cuando el pool de listas no esta en primer plano, para evitar peticiones innecesarias
 * Debe de controlarse las peticiones, para evitar varias en el mismo momento
 * @returns
 */
const listsWithUsers = () => (dispatch) => {
  return apiPools.listsUsers({ action: 'count' }).then((result) => {
    if (result.status === 200) {
      dispatch({ type: types.LISTS_WITH_USERS, listsWithUsers: result.data.listsWithUsers, withLists: true })
    }
    return ({ status: result.status, data: result.data })
  }).catch((error) => {
    console.error(error)
  })
}

/**
 * Cuando el pool de listas esté en primer plano
 * Debe de controlarse las peticiones, para evitar varias en el mismo momento
 * @returns
 */
const listsAndUsers = ({ selectType, channels, brands, delegations }) => async (dispatch, getState) => {
  const { user: { frontOptions }, tabs } = getState()


  const initialSelectType = selectType?.value || frontOptions?.poolListSelectType?.value
  if (!['all', 'openedTabs'].includes(initialSelectType)) {
    selectType = initialSelectType
  } else {
    selectType = null
  }

  if (channels?.length) {
    const channelsList = []
    channels.map(channel => channelsList.push(channel.value))
    channels = channelsList
  }

  if (brands?.length) {
    const brandsList = []
    brands.map(brand => brandsList.push(brand.value))
    brands = brandsList
  }

  if (delegations?.length) {
    const delegationsList = []
    delegations.map(delegation => delegationsList.push(delegation.value))
    delegations = delegationsList
  }

  try {
    const { data } = await apiPools.listsUsers({
      action: 'listsAndUsers',
      selectType,
      channels,
      brands,
      delegations
    })

    const lists = [...data.lists]

    const listIds = lists.map(elem => elem._id)
    // Remove invalid item from lists
    const operatorPoolListOrder = (frontOptions.poolListOrder || []).filter(it => listIds.includes(it))
    const poolListOrder = [...new Set([...operatorPoolListOrder, ...listIds])]

    // Filter users in open tabs
    if (initialSelectType === 'openedTabs') {
      for (const list of lists) {
        const listIndex = lists.findIndex(listsItem => listsItem._id === list._id)
        const filteredUsers = list.users.filter(user => tabs.users?.some(e => e.id === user.id))
        lists[listIndex].users = filteredUsers
      }
    }

    dispatch({
      type: types.LISTS_AND_USERS,
      lists,
      listsWithUsers: data.listsWithUsers,
      withLists: true,
      poolListOrder
    })

    return true
  } catch(error) {
    return false
  }
}

/**
 * Se usa cuando se recibe un evento del socket
 * @param {object} options
 * @param {boolean} [options.onlyListIsAvailable] Fuerza a ejecutar el evento solo en el caso que esté la lista disponible
 * @param {boolean} [options.withLists] Cuando el operador se loguea, y llega con valor false, no se realiza la petición de obtener datos
 *
 * @returns {boolean}
 */
const event = (options = {}) => (dispatch, getState) => {
  const { onlyListIsAvailable = false, withLists } = options

  if (onlyListIsAvailable) {
    const { isListsAvailable } = getState().poolLists

    if (!isListsAvailable) return true
  }

  if (withLists !== undefined && !withLists) {
    dispatch(updateIsListAvailable(withLists))
    return true
  }

  const isListLocation = window.location.href.indexOf('/conversations/lists')
  if (isListLocation > 0)
    dispatch(listsAndUsers({}))
  else
    dispatch(listsWithUsers())

  return true
}

/**
 * Collapse lists
 * @returns
 */
const collapse = (collapse) => (dispatch) => {
  dispatch({ type: types.COLLAPSE, collapse: collapse })
}

const getListsByUser = (userId) => async () => {
  return apiPools.getListsByUser(userId)
    .then((result) => {
      return result.data
    }).catch((error) => {
      console.error(error)
    })
}

const edit = (data) => async () => {
  return apiPools.listEdit(data)
    .then((result) => {
      return ({ status: result.status, data: result.data })
    }).catch((error) => {
      console.error(error)
    })
}

const removeFromList = (data) => async (dispatch) => {
  try {
    await apiPools.listEdit(data)
    dispatch(incrementRemoveFromLists())

    return true
  } catch(error) {
    return false
  }
}

const updateListOrder = (data) => (dispatch) => {
  dispatch({
    type: types.UPDATE_LIST_ORDER,
    poolListOrder: data
  })
}

export default {
  listsWithUsers,
  listsAndUsers,
  event,
  collapse,
  getListsByUser,
  edit,
  removeFromList,
  updateListOrder
}
